import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-heading font-bold text-charcoal text-lg">{title}</h2>
    <div className="mt-3 space-y-3 text-[15px] text-zinc-600 leading-relaxed">{children}</div>
  </div>
);

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-offwhite" data-testid="terms-of-use-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-20">
        <p className="text-[11px] font-semibold tracking-[0.28em] text-forest uppercase mb-4">Legal</p>
        <h1 className="font-heading font-extrabold tracking-tight text-charcoal text-3xl sm:text-4xl" data-testid="terms-heading">
          Terms of Use
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Westline Technologies — Western Australia, Australia. Last updated: July 2026.</p>

        <Section title="1. General information only">
          <p>
            The content on this website is provided for general information purposes only. It describes the types
            of systems and services Westline Technologies designs and builds, and is not advice tailored to any
            specific business. You should consider your own circumstances before acting on anything published here.
          </p>
        </Section>

        <Section title="2. Illustrative examples">
          <p>
            Examples shown on this website — including the management dashboard illustration, workflow diagrams,
            staged implementation progression and lists of potential benefits — are illustrative only. Dashboard
            figures are fictional demonstration data. They are provided to explain concepts, not to represent any
            actual client, business or result.
          </p>
        </Section>

        <Section title="3. No guaranteed outcomes">
          <p>
            Nothing on this website constitutes a promise or guarantee of any financial, operational or commercial
            improvement. The value created by any system depends on the individual business, its processes and how
            the system is adopted. Any estimates or projections are discussed and agreed separately, in writing,
            as part of a specific engagement.
          </p>
        </Section>

        <Section title="4. Engagements, scope and pricing">
          <p>
            Any work performed by Westline Technologies is subject to a separate agreement between Westline Technologies and
            the client. Project scope, deliverables, timelines and pricing are agreed in writing before work
            begins. Submitting an enquiry through this website does not create a client relationship or any
            obligation on either party.
          </p>
        </Section>

        <Section title="5. Intellectual property">
          <p>
            The content, design, text and graphics of this website are the intellectual property of Westline
            Systems and may not be reproduced, distributed or used for commercial purposes without written
            permission. Intellectual property terms for systems we build are set out in the agreement for each
            engagement.
          </p>
        </Section>

        <Section title="6. External services and integrations">
          <p>
            Systems built by Westline Technologies may integrate with third-party software and services (for example,
            accounting platforms such as Xero). Those services are operated by their respective providers, are
            subject to their own terms and conditions, and Westline Technologies is not responsible for their
            availability, changes or pricing.
          </p>
        </Section>

        <Section title="7. Website availability and accuracy">
          <p>
            We take reasonable care to keep the information on this website accurate and up to date, but we make
            no warranties that it is complete, current or error-free. We may change the content of this website at
            any time without notice. To the extent permitted by law, Westline Technologies excludes liability for any
            loss arising from use of, or reliance on, this website.
          </p>
        </Section>

        <Section title="8. Acceptable use">
          <p>
            You must not misuse this website, attempt to gain unauthorised access to any part of it or its
            systems, or use the enquiry form to submit false, misleading or unlawful content.
          </p>
        </Section>

        <Section title="9. Changes to these terms">
          <p>
            We may update these Terms of Use from time to time. The current version will always be available on
            this page.
          </p>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
